import React from 'react'
import {Tag} from 'antd'
import {DeleteOutlined, LoadingOutlined} from '@ant-design/icons'
import {Scrollbars} from 'react-custom-scrollbars'
import {humanFileSize} from '../../helpers/helpers'
import styles from './UploadFileItem.module.scss'
import {useComponentLocale} from '../../hooks/useComponentLocale'

function UploadFileItem({fileList, onRemove, isUploading, isUploadFinished, isParsing, isFullFinished}) {
    const getLocale = useComponentLocale()
    const processedLocale = getLocale({component: 'tags', section: 'processed'})
    const uploadedLocale = getLocale({component: 'tags', section: 'uploaded'})
    const notSupportedLocale = getLocale({component: 'tags', section: 'not_supported'})


    const getTagByStatus = (status) => {

        // parse is done
        if (isFullFinished){
            // go for statuses
            if (status === 'added') {
                return (
                    <>
                        <Tag color='success'>
                            Uploaded
                        </Tag>
                        <Tag color='success'>
                            Parsed
                        </Tag>
                    </>)
            }

            if (status === 'error') {
                return (
                    <>
                        <Tag color='success'>
                            Uploaded
                        </Tag>
                        <Tag color='error'>
                            {notSupportedLocale}
                        </Tag>
                    </>)
            }
        }

        // loading not parsed
        if (isUploading) {
            return (
                <>
                    <Tag color='processing'>
                        <LoadingOutlined/> Uploading
                    </Tag>
                    <Tag color='processing'>
                        To be parsed
                    </Tag>
                </>
            )
        }

        // uploaded and going to parsed
        else if (isUploadFinished) {
            return (
                <>
                    <Tag color='success'>
                        Uploaded
                    </Tag>
                    <Tag color='processing'>
                        To be parsed
                    </Tag>
                </>
            )
        }

        else if (isParsing) {
            if (status !== 'parsed') {
                return (
                    <>
                        <Tag color='success'>
                            Uploaded
                        </Tag>
                        <Tag color='processing'>
                            <LoadingOutlined/> Parsing
                        </Tag>
                    </>
                )
            }
            else if (status === 'parsed') {
                return (
                    <>
                        <Tag color='success'>
                            Uploaded
                        </Tag>
                        <Tag color='success'>
                            Parsed
                        </Tag>
                    </>
                )
            }
        }


    }

    if (!fileList.length) {
        return null
    }

    return (
        <div className={!isParsing && isUploadFinished ? styles.container : styles.container100}>
            <Scrollbars
                renderThumbVertical={({style, ...props}) => (
                    <div {...props} style={{...style, backgroundColor: '#5a6268', borderRadius: '3px'}}/>
                )}
            >
                {fileList.map((file) => (
                    <div key={file.uid} className={styles.flex}>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                width: '100%',
                            }}
                            className='ant-upload-list-item ant-upload-list-item-done ant-upload-list-item-list-type-text'
                        >
                            <div className='ant-upload-list-item-info' style={{width: '100%'}}>
								<span style={{display: 'flex', flexDirection: 'row', width: '100%', paddingLeft: !isParsing ? 0 : 'inherit'}}>
                      {
                          !isParsing && !isFullFinished ?
                              <div className='ant-upload-text-icon'>
                                  <span>
                                    <DeleteOutlined onClick={() => onRemove(file)}/>
                                  </span>
                              </div>
                              : null
                      }

                    <span className='ant-upload-list-item-name ant-upload-list-item-name-icon-count-1'>
										{file.name} - {humanFileSize(file.size)}
									</span>

                    {isParsing || isFullFinished ? getTagByStatus(file.status) : null}
								</span>
                            </div>
                        </div>
                    </div>
                ))}
            </Scrollbars>
        </div>
    )
}

export default UploadFileItem
